/**
 * @typedef {Object} ToothNumberDO
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number[]} toothNumberList - The tooth number list
 */

/**
 * @type {ToothNumberDO[]}
 */
const toothNumberListSingle = [];
const toothNumberMapSingle = {};

/**
 * @param {ToothNumberDO} toothNumberDO
 */
const addToothNumberDO = (toothNumberDO) => {
  toothNumberListSingle.push(toothNumberDO);
  toothNumberMapSingle[toothNumberDO.toothGumType] = toothNumberDO;
};


/**
 * @param {string} gumType
 * @param {number} toothIndex
 * @returns {number | null}
 */

const getToothNumberByGumTypeAndToothIndex = (gumType, toothIndex) => {
  try {
    return toothNumberMapSingle[gumType].toothNumberList[toothIndex - 1];
  } catch (error) {
    return null;
  }
};

const getToothNumberListByGumType = (gumType) => {
  return toothNumberMapSingle[gumType];
};

export default {
  addToothNumberDO,
  getToothNumberByGumTypeAndToothIndex,
  getToothNumberListByGumType,
};
